import type { MetroStation, Place } from '../domain/types';
import { Icon } from './Icon';
import { LineDots } from './LineDots';

interface StationCardProps {
  station: MetroStation;
  places: readonly Place[];
  favorite: boolean;
  onFavoriteChange: (favorite: boolean) => void;
}

export function StationCard({ station, places, favorite, onFavoriteChange }: StationCardProps) {
  const want = places.filter((place) => place.status === 'want').length;
  const visited = places.length - want;

  return (
    <article className="station-card">
      <a className="station-card__link" href={`#/station/${encodeURIComponent(station.id)}`}>
        <h3 className="station-card__name">{station.name}</h3>
        <div className="station-card__meta">
          <LineDots lines={station.lines} />
          <span className="station-card__counts">
            <span>Всего {places.length}</span>
            <span>Хочу {want}</span>
            <span>Был {visited}</span>
          </span>
        </div>
      </a>
      <button
        className="station-card__favorite"
        type="button"
        aria-label={favorite ? `Убрать станцию «${station.name}» из избранного` : `Добавить станцию «${station.name}» в избранное`}
        aria-pressed={favorite}
        onClick={() => onFavoriteChange(!favorite)}
      >
        <Icon name="star" />
      </button>
    </article>
  );
}
